// extracted by mini-css-extract-plugin
module.exports = {"TCC__verification_page":"style_TCC__verification_page__2r1lR","form":"style_form__O1MU0"};